const Orange = {
    title: 'Orange',
    background: 'radial-gradient(circle, #b07f5b 0%, #ba692f 100%)',
    colors: {
        primary: '#db7f0d',
        secondary: '#d48626',
        terciary: '#d19041',
        fourth: '#fcf3e8',
        fifth: '#fcf9f5'
    }
};

export default Orange;